import React from "react";
import ListView from "../../../common/list";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import RoleUsersListViewModel from "viewModels/users/roles/detail/roleUsersListViewModel";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type User from "entities/user";

export const RoleUsersListView: ViewComponent<RoleUsersListViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<User>[] = [
    {
      title: vm.translate("fullName"),
      valueFormatter: ({ item }) => `${item.firstName} ${item.lastName}`,
    },
    {
      title: vm.translateAttribute("email"),
      property: "email",
    },
    {
      title: vm.translateAttribute("phoneNumber"),
      property: "phoneNumber",
    },
  ];

  return <ListView vm={vm} columns={columns} showDetailWithList={true} hideTitle={true} />;
});

registerView(RoleUsersListView, RoleUsersListViewModel);
